import {
  PartialQuestionnaire,
  QuestionnaireQuestions,
  Rule,
} from '../../models';
import { findPath } from '../findPath';

/**
 *
 * Helper functionality to check if a questionnaire is in a valid state.
 * The result is calculated depending on the required questionnaire questions
 * and the provided answers.
 *
 */
export const isValid = <
  Questionnaire extends QuestionnaireQuestions,
  GroupId,
  ExtendedTypes
>(
  questionnaire: PartialQuestionnaire<Questionnaire, GroupId, ExtendedTypes>,
  answers: Partial<Questionnaire>,
  rules: Rule<Questionnaire>[]
) => {
  const requiredPaths = findPath(questionnaire, answers, rules);
  for (const requiredPath of requiredPaths) {
    const answer = answers[requiredPath];
    if (!answer) {
      return false;
    }
  }
  return true;
};
